<div class="list-loading-spinner_spinner" inViewport (visible)="spinnerVisible = $event">
  @if (spinnerVisible) {
    <mat-spinner [diameter]="44" [strokeWidth]="4" [color]="color"></mat-spinner>
  }
</div>
